function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeartFill = function SvgIconHeartFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    stroke: props.color,
    d: "M19.585 5.415A4.88 4.88 0 0 0 16.173 4c-1.036 0-2.09.327-2.946.996a4.506 4.506 0 0 0-.465.419l-.774.78-.75-.756a4.785 4.785 0 0 0-3.411-1.415c-1.234 0-2.492.464-3.412 1.415a4.916 4.916 0 0 0 0 6.902l1.621 1.635L11.988 20l5.976-6.049 1.62-1.634a4.916 4.916 0 0 0 0-6.902z",
    clipRule: "evenodd"
  }));
};
export default SvgIconHeartFill;